import { FaGithub, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="flex justify-end py-8 mt-32 space-x-2 border-t border-t-blue-500">
      <div className="container flex items-center space-x-4 group">
          <p className="mr-4 text-sm hover:text-blue-500">made by Donika</p>
        <a
          href="https://github.com/donikasela"
          target="_blank"
          rel="noopener noreferrer"
          className="transition text-slate-800 hover:text-blue-500"
        >
          <FaGithub size={24} />
        </a>
        <a
          href="https://www.linkedin.com/in/donika-sela-03a812262"
          target="_blank"
          rel="noopener noreferrer"
          className="transition text-slate-800 hover:text-blue-500"
        >
          <FaLinkedin size={24} />
        </a>

        <br />
      </div>
    </div>
  );
};

export default Footer;
